import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import constants from "../../../../constants";
import * as actions from "../../../../store/actions";
import { getUserData } from "../../../../utils/localStorage";

import AcceptModal from "../PopupModal/AcceptModal";
import AppointmentDetailInfo from "./AppointmentDetailInfo";

const AppointmentDetail = ({
  match,
  appointmentData,
  getAppointmentDetail,
  updateAppointmentStatus,
  updateGuestDoctorRequest,
}) => {
  const id = match?.params?.id;

  useEffect(() => {
    getAppointmentDetail(id);
    //eslint-disable-next-line
  }, [id]);

  const [isOpen, setIsOpen] = useState(undefined);

  let openModal = value => {
    setIsOpen(value);
  };
  let closeModal = () => {
    setIsOpen(undefined);
  };

  const isGuest = appointmentData?.guest_doctor_id === getUserData()?.id;

  return (
    <>
      <AcceptModal
        isOpen={isOpen}
        closeModal={() => closeModal()}
        appointmentData={appointmentData}
        onUpdate={isGuest ? updateGuestDoctorRequest : updateAppointmentStatus}
        onAcceptSuccess={() => getAppointmentDetail(id)}
      />

      {!appointmentData?.status ? (
        <>
          <p className="content-center"></p>
        </>
      ) : (
        <div className="row mt-0">
          <div
            style={{
              padding: 30,
            }}
            className="col col-md-12 scheduled"
          >
            <AppointmentDetailInfo
              appointmentData={appointmentData}
              onAccept={() =>
                isGuest
                  ? updateGuestDoctorRequest(
                      appointmentData?.id,
                      constants.APPOINTMENT_STATUS.accepted,
                      () => getAppointmentDetail(id)
                    )
                  : updateAppointmentStatus(
                      appointmentData?.id,
                      constants.APPOINTMENT_STATUS.accepted,
                      () => getAppointmentDetail(id)
                    )
              }
              onDeny={() => openModal("deny")}
              onReschedule={() => openModal("reschedule")}
              onCancel={() => openModal("cancel")}
              onGuestSuccess={() => getAppointmentDetail(id)}
              onCancelInvite={updateGuestDoctorRequest}
            />
          </div>
        </div>
      )}
    </>
  );
};

const mapStoreToProps = ({ dashboard }) => ({
  appointmentData: dashboard.appointments.appointmentDetail,
});

const mapDispatchToProps = dispatch => ({
  getAppointmentDetail: appointmentId =>
    dispatch(actions.getAppointmentDetail(appointmentId)),
  updateAppointmentStatus: (id, status, cb) =>
    dispatch(actions.updateAppointmentStatus(id, status, cb)),
  updateGuestDoctorRequest: (id, status, cb) =>
    dispatch(actions.updateGuestDoctorRequest(id, status, cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(AppointmentDetail)
);
